<template>
  <div class="w-full">
      <div class="text-center text-3xl py-6">{{ _("You are already engaged with :count deliveries. Deliver your orders before grabbing new ones. Thanks!").split(":count").join(orders) }}</div>
  </div>
</template>

<script>
import PhoneFormatter from "../Shared/PhoneFormatter";
import {lang} from "../lang";
import IconClockOutline from "../../icons/outline/IconClockOutline";
export default {
  name: "CannotGrab",
    components: {IconClockOutline, PhoneFormatter},
    props: [
        'app_locale', 'orders'
    ],
    data() {
        return {
            grabbing: false,
        }
    },
    
    methods: {
      
      
        _(k) {
            return lang(k, this.app_locale === 'fr_CA' ? 'fr' : 'en')
        },
    }
}
</script>

<style scoped>

</style>
